// extracted by mini-css-extract-plugin
export default {"actionText":"BackButton_actionText__rBKxP","text":"BackButton_text__t3NC0"};